import { render, staticRenderFns } from "./Invest.vue?vue&type=template&id=b3f91a70&"
import script from "./Invest.vue?vue&type=script&lang=ts&"
export * from "./Invest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports